export default "__VITE_ASSET__DdfMEN1J__"